import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13d8ac69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "card-header row d-flex align-items-center"
}
const _hoisted_3 = { class: "d-flex flex-column flex-md-row align-items-center py-3 w-100" }
const _hoisted_4 = { class: "d-flex flex-row flex-md-column pe-0 pe-md-2 mb-2 mb-md-0" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Show only my jobs")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Fully display jobs")
const _hoisted_7 = { class: "d-flex w-100 flex-column" }
const _hoisted_8 = { class: "d-flex flex-column flex-md-row w-100 mb-3 mb-md-2" }
const _hoisted_9 = { class: "d-flex flex-column flex-md-row w-100" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "demo-app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_CountriesDropdown = _resolveComponent("CountriesDropdown")!
  const _component_BranchesDropdown = _resolveComponent("BranchesDropdown")!
  const _component_CompaniesDropdown = _resolveComponent("CompaniesDropdown")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_CustomEvent = _resolveComponent("CustomEvent")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.userId == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.showMyJobs,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showMyJobs) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                onChange: _ctx.forceCalenderRerender,
                modelValue: _ctx.collapseAllJobs,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collapseAllJobs) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onChange", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_CountriesDropdown, {
                  modelValue: _ctx.inputModels.countryID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputModels.countryID) = $event)),
                  class: "w-100 me-0 me-md-2 mb-3 mb-md-0",
                  onChange: _ctx.searchByCountry
                }, null, 8, ["modelValue", "onChange"]),
                _createVNode(_component_BranchesDropdown, {
                  class: "w-100 ms-0 ms-md-2",
                  modelValue: _ctx.inputModels.branchID,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputModels.branchID) = $event)),
                  onChange: _ctx.searchByBranch
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (!_ctx.$can('view_only_own_company_jobs', 'all'))
                  ? (_openBlock(), _createBlock(_component_CompaniesDropdown, {
                      key: 0,
                      modelValue: _ctx.inputModels.companies,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputModels.companies) = $event)),
                      onChange: _ctx.searchByClient,
                      class: "w-100 me-0 me-md-2 mb-3 mb-md-0"
                    }, null, 8, ["modelValue", "onChange"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_autocomplete, {
                  class: "w-100 ms-0 ms-md-2",
                  modelValue: _ctx.inputModels.searchedUserId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputModels.searchedUserId) = $event)),
                  clearable: "true",
                  debounce: "400",
                  size: "large",
                  "fetch-suggestions": _ctx.searchUsers,
                  placeholder: "Filter by user",
                  onSelect: _ctx.searchByUser,
                  onClear: _ctx.handleClearUserSearch
                }, null, 8, ["modelValue", "fetch-suggestions", "onSelect", "onClear"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
          key: 1,
          class: "overlay-spinner"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_FullCalendar, {
          options: _ctx.calendarOptions,
          class: "demo-app-calendar"
        }, {
          eventContent: _withCtx((data) => [
            _createVNode(_component_CustomEvent, {
              collapseAllJobs: _ctx.collapseAllJobs,
              event: data
            }, null, 8, ["collapseAllJobs", "event"])
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ])
  ]))
}